//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SkockKittingDatailedDebitsBanner',
  props: {
    request: {
      type: Object,
      required: true
    }
  }
}
